import { cn } from '../../lib/cn';
import type { PlatformOpsRow } from '../../platformadmin/framework';

type Props = { metrics?: PlatformOpsRow[] };

function healthColor(health: string) {
  switch (health) {
    case 'healthy': return 'text-success-600';
    case 'degraded': return 'text-warning-600';
    default: return 'text-error-600';
  }
}

export function PlatformOperationsPanel({ metrics = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-6">
      {metrics.map((m) => (
        <div key={m.metric} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{m.metric}</p>
          <p className="mt-1 text-sm font-semibold">{m.value}</p>
          <p className={cn('text-xs font-medium capitalize', healthColor(m.health))}>{m.health}</p>
        </div>
      ))}
    </div>
  );
}
